export type BusinessReportOutcomeExportFormat = "docx" | "xlsx" | "csv";

export const BUSINESS_REPORT_OUTCOME_EXPORT_OPTIONS: Array<{
  format: BusinessReportOutcomeExportFormat;
  label: string;
}> = [
  { format: "docx", label: "Export to Word" },
  { format: "xlsx", label: "Export to XLS" },
  { format: "csv", label: "Export to CSV" },
];

export const getBusinessReportOutcomeExportUrl = (
  businessReportOutcomeId: string,
  format: BusinessReportOutcomeExportFormat,
): string =>
  `/pf-mainweb/business-reports/business-report-outcome/export?business_report_outcome_id=${businessReportOutcomeId}&format=${format}`;
